<template>
  <el-card shadow="never" class="aui-card--fill">
	  <el-row style="background-color: #F3F4F4;">
	  	<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
	  		<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
	  		收票方地址信息管理
	  	</el-col>
	  	<el-col :xs="24" :md="18">
	  		<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
	  			<el-form-item>
	  			  <el-button v-if="$hasPermission('plat:platticketpick:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
	  			</el-form-item>
	  			<el-form-item>
	  			  <el-button v-if="$hasPermission('plat:platticketpick:update')" type="success" @click="defaultHandle()">设为默认</el-button>
	  			</el-form-item>
	  			<el-form-item><el-button type="info" @click="getDataList()">刷新</el-button></el-form-item>

				<el-form-item>
				  <el-button v-if="$hasPermission('plat:platticketpick:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
				</el-form-item>
			</el-form>
	  	</el-col>
	  </el-row>
    <div class="mod-plat__platticketpick}">
      <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{(page - 1) * limit + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="编码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="pickName" label="收票人姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="pickAddress" label="收票人地址" header-align="center" align="center"></el-table-column>
        <el-table-column prop="phone" label="收票人电话" header-align="center" align="center"></el-table-column>
        <el-table-column prop="email" label="电子邮箱地址" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isDefault" label="是否默认" header-align="center" align="center">
          <template slot-scope="scope">
            {{ $getDictLabel("isOrNot", scope.row.isDefault) }}
          </template>
        </el-table-column>
        <el-table-column prop="isEnable" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            {{ $getDictLabel("isEnable", scope.row.isEnable) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="scope.row.isEnable === '0'" type="text" size="small"
                       @click="$hasPermission('plat:platticketpick:update') && enableOrDisableHandle(scope.row.id,1)">启用
            </el-button>
            <el-button v-if="scope.row.isEnable === '1'" type="text" size="small"
                       @click="$hasPermission('plat:platticketpick:update') && enableOrDisableHandle(scope.row.id,0)">停用
            </el-button>
            <el-button v-if="$hasPermission('plat:platticketpick:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('plat:platticketpick:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
	  background
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './platticketpick-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/ticket/pick/page',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/ticket/pick',
        deleteIsBatch: true
      },
      dataForm: {
        code: '',
        pickName: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {
    defaultHandle () {
      if (this.mixinViewModuleOptions.deleteIsBatch && !this.id && this.dataListSelections.length <= 0) {
        return this.$message({
          message: '请选择设置默认项',
          type: 'warning',
          duration: 500
        })
      }
      if(this.dataListSelections.length > 1){
        return this.$message({
                  message: '设置默认项只能选择一条数据',
                  type: 'warning',
                  duration: 1000
                })
      }
      let ids = this.dataListSelections.map(item => item[this.mixinViewModuleOptions.deleteIsBatchKey])
      for (let i = 0; i < ids.length; i++) {
        this.$http.get('/sys/plat/ticket/pick/setDefault', {
          params: {
            id: ids[i]
          }
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          if (i == ids.length - 1) {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.query()
              }
            })
          }
        }).catch(() => {})
      }
    },
    enableOrDisableHandle (id, isEnable) {
      var str = '启用'
      if (isEnable == 0) {
        str = '禁用'
      }
      this.$confirm('此操作将' + str + '此条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handle(id, isEnable)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    handle (id, isEnable) {
      this.$http.get('/sys/plat/ticket/pick/enableOrDisable', {
        params: {
          id: id,
          isEnable: isEnable
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        } else {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.query()
            }
          })
        }
      }).catch(() => {})
    }
  }
}
</script>
